import { render, staticRenderFns } from "./updatevatdiag.vue?vue&type=template&id=3f729592&scoped=true&"
import script from "./updatevatdiag.vue?vue&type=script&lang=js&"
export * from "./updatevatdiag.vue?vue&type=script&lang=js&"
import style0 from "./updatevatdiag.vue?vue&type=style&index=0&id=3f729592&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f729592",
  null
  
)

export default component.exports